<template>
  <div class="container">
    <div>
      <div class="row mx-0 mt-4 mb-3 justify-content-between">
        <back-arrow v-if="operationId" :bilan-type="bilanType" :params="{operationId: operationId}" :sub-title-ope="operationName"
                    :title="$t('Operation.planning')"
                    routeBack="OperationShow"/>
        <div v-if="operation && operation !==[] && operation.length > 0" class="row mx-0 align-items-center">
          <b-button v-if="!isGlobal" class="mr-2" variant="outline-primary" v-on:click="handleAddEvenement()">
            {{ $t('Modify') }}
          </b-button>
        </div>
      </div>
      <div>
        <operation-show-planning-operation
          v-if="!isLoading && operation && operation !==[] && operation.length > 0 && !isGlobal"
          :operations="operation"/>

        <operation-planning
          v-else-if="!isLoading && operation && operation !==[] && operation.length > 0 && isGlobal"
          :operations="operation"/>

      </div>
    </div>
    <b-row v-if="!operation || operation === [] || operation.length <= 0" align-h="center" class="row mx-0 mt-4">
      <div class="col-md-5 text-center">
        <img :src="require(`@/assets/images/APRILYOS/empty-table.png`)" alt="no result" class="mt-4 mb-2 no-result-img"
             style="max-height: 25%;">

        <div class="main-color-text-text bold-text level-two-title">
          {{ $t('operationPlanning.emptyTitle') }}
        </div>

        <div v-if="!isGlobal" class="main-color-text">
          {{ $t('operationPlanning.emptyText') }}
        </div>

        <div v-else class="main-color-text">
          {{ $t('operationPlanning.global.emptyText') }}
        </div>

        <b-button v-if="!isGlobal" class="my-2" variant="primary" @click="handleAddEvenement">
          {{ $t('operationPlanning.emptyButton') }}
        </b-button>
      </div>
    </b-row>
  </div>
</template>

<script>
import OperationShowPlanningOperation from '../../operationPlanning/OperationShowPlanningOperation'
import OperationPlanning from '../../operationPlanning/OperationPlanning'
import api from "../../../services/api";
import BackArrow from "../../../components/b122/BackArrow.vue";

export default {
  name: "OperationShowPlanning",

  props: {
    isGlobalProps: {
      required: false,
      type: Boolean,
      default: false,
    }
  },


  data() {
    return {
      operationId: this.$route.params.operationId,
      isGlobal: this.$route.params.isGlobal,
      operation: [],
      isLoading: true,
      bilanType: null,
      operationName: null,

    }
  },
  components: {
    BackArrow,
    OperationShowPlanningOperation,
    OperationPlanning
  },

  async mounted() {
    if (!this.isGlobal) {

      this.isGlobal = this.isGlobalProps
    }
    if (this.operationId && !this.isGlobal) {
      await this.fetchOperationName()
      await this.fetchOperation()

      await this.getOperationBilanType()
    } else {
      await this.fetchAllOperations()
    }
  },

  methods: {

    async fetchOperationName() {
      await api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operationName = response.data.name
        })
    },


    handleAddEvenement() {
      this.$router.push({
        name: 'OperationEvenementCreateEdit',
        params: {
          operationId: Number(this.operationId),
        }
      })
    },
    async fetchOperation() {
      this.isLoading = true
      api
        .get(`/operation/getOperationAndLotsPlanning/${this.operationId}`)
        .then(response => {
          if (response.data) {
            this.operation.push(response.data)
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getOperationBilanType() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.bilanType = response.data.bilanType
          })
      }
    },

    async fetchAllOperations() {
      this.isLoading = true;
      api
        .get(`/operation/getAllOperationsAndLotsPlanning`)
        .then(response => {
          this.operation = response.data
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShowTabs/OperationShowPlanning.vue